import { render, staticRenderFns } from "./user-multiple.vue?vue&type=template&id=941f6db4&scoped=true&"
import script from "./user-multiple.vue?vue&type=script&lang=js&"
export * from "./user-multiple.vue?vue&type=script&lang=js&"
import style0 from "./user-multiple.vue?vue&type=style&index=0&id=941f6db4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941f6db4",
  null
  
)

export default component.exports